import { render, staticRenderFns } from "./SubjectNewForm.vue?vue&type=template&id=b11231a6"
import script from "./SubjectNewForm.vue?vue&type=script&lang=js"
export * from "./SubjectNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports